<div class="neq-container">
  <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
    <!-- Leaf node -->
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding [ngClass]="{'drop-above': dragNodeExpandOverArea === 'above' && dragNodeExpandOverNode === node,
    'drop-below': dragNodeExpandOverArea === 'below' && dragNodeExpandOverNode === node,
    'drop-center': dragNodeExpandOverArea === 'center' && dragNodeExpandOverNode === node}" draggable="true"
      (dragstart)="handleDragStart($event, node);" (dragover)="handleDragOver($event, node);"
      (drop)="handleDrop($event, node);" (dragend)="handleDragEnd($event);">
      <div fxLayoutAlign="start center">
        <neq-icon svgIcon="chevron-droit"></neq-icon>
        <span class="tree-label">{{node.code}} - {{node.label}}</span>
      </div>
    </mat-tree-node>

    <!-- expandable node -->
    <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding [ngClass]="{'drop-above': dragNodeExpandOverArea === 'above' && dragNodeExpandOverNode === node,
  'drop-below': dragNodeExpandOverArea === 'below' && dragNodeExpandOverNode === node,
  'drop-center': dragNodeExpandOverArea === 'center' && dragNodeExpandOverNode === node}" draggable="true"
      (dragstart)="handleDragStart($event, node);" (dragover)="handleDragOver($event, node);"
      (drop)="handleDrop($event, node);" (dragend)="handleDragEnd($event);" (click)="loadChildren(node)" (keyDown)="loadChildren(node)" matTreeNodeToggle>
      <div fxLayoutAlign="start center">
        <span class="tree-label">{{node.code}} - {{node.label}}</span>
        <neq-icon *ngIf="treeControl.isExpanded(node)" svgIcon="chevron-haut"></neq-icon>
        <neq-icon *ngIf="!treeControl.isExpanded(node)" svgIcon="chevron-bas"></neq-icon>
        <mat-progress-spinner *ngIf="node.isLoading" mode="indeterminate" diameter="24"></mat-progress-spinner>
      </div>
    </mat-tree-node>
  </mat-tree>
</div>
